// Names and descriptions live in onboarding.json under standard_roles.<id>
export const STANDARD_ROLES = [
  {
    id: 'dentist',
    permissions: [
      'task:read', 'task:create', 'task:update',
      'equipment:read', 'room:read', 'inventory:item:read', 'inventory:stock:read',
    ],
  },
  {
    id: 'hygienist',
    permissions: [
      'task:read', 'task:create', 'task:update',
      'equipment:read', 'room:read', 'inventory:item:read', 'inventory:stock:read',
    ],
  },
  {
    id: 'coordinator',
    permissions: [
      'task:read', 'staff:read', 'room:read',
      'equipment:read', 'inventory:item:read', 'inventory:stock:read',
      'inventory:stock:record', 'inventory:stock:manage',
    ],
  },
  {
    id: 'sterilization',
    permissions: ['task:read', 'task:create', 'task:update', 'equipment:read'],
  },
  {
    id: 'manager',
    permissions: [
      'staff:read', 'staff:create', 'staff:update',
      'role:read', 'task:read', 'task:create', 'task:update',
      'equipment:read', 'room:read', 'inventory:item:read', 'inventory:stock:read',
      'inventory:cost:read', 'inventory:cost:update',
    ],
  },
];
